import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Le panel a trois espaces :
 * - supervision : dashboard, stats, staff, modération... (le panel actuel)
 * - configuration : édition in-game (packs Minecraft : blocks, items, entities, crafts)
 * - deploiement : gestion des déploiements (API, packs)
 */
export type PanelSpace = 'supervision' | 'configuration' | 'deploiement';

interface SpaceState {
  space: PanelSpace;
  setSpace: (space: PanelSpace) => void;
}

export const useSpaceStore = create<SpaceState>()(
  persist(
    (set) => ({
      space: 'supervision',
      setSpace: (space) => set({ space }),
    }),
    {
      name: 'recubebe-space',
      partialize: (state) => ({ space: state.space }),
    }
  )
);
